// Re-export shim. The API client implementation lives in @adrodd/core so it can
// be shared with the React Native app — see packages/core/src/apiClient.ts.
//
// Web-specific wiring: the base URL comes from Vite-injected env via runtimeEnv
// (relative '' by default so requests are proxied by the frontend server; an
// absolute URL if VITE_API_URL is set). This runs once when the module is first
// imported, before any request is made. Existing imports of `@/lib/apiClient`
// continue to work unchanged.
import { apiClient, configureApiClient } from '@adrodd/core';
import runtimeEnv from './runtimeEnv';
import { applyViewAsPlanInterceptor } from './viewAsPlanInterceptor';
import { applyFirstTouchInterceptor, captureFirstTouch } from './firstTouch';
import { configureErrorReporter, installGlobalErrorHandlers } from './errorReporting';

configureApiClient({ baseURL: runtimeEnv.getApiUrl(), platform: 'web' });

// Crash reporting: what the browser can say about this device, plus the
// window-level handlers React error boundaries never see. Configured here so
// it is live as soon as anything imports the API client.
configureErrorReporter();
installGlobalErrorHandlers();

// Web-only: forward the admin "view as plan" preview as the X-View-As-Plan
// header (see viewAsPlanInterceptor). Extracted so it can be unit-tested
// without pulling in Vite's runtimeEnv. Runs alongside the shared core
// interceptor chain (which also attaches the JWT); order is irrelevant.
applyViewAsPlanInterceptor(apiClient);

// Web-only: remember where the visitor first came from and forward it so a
// signup can be attributed (see firstTouch).
captureFirstTouch();
applyFirstTouchInterceptor(apiClient);

export * from '@adrodd/core';
export { default } from '@adrodd/core/apiClient';
